module.exports = __webpack_public_path__ + "media/images/tile-wide-9e638f2265431c090790eef3d0c534f9.png";